import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnInit
} from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ApConfig } from 'src/app/classes/models';
import { buildApConfigSelectionMap } from 'src/app/services/ap-config.service';

// VPDW-763: lets a Client user (and VIVE Admin) designate which accounting
// system(s) a vendor is created in. Rendered only when the client has 2+
// create-eligible systems; reuses the shared app-multi-select (which provides the
// "select one / multiple / all" behavior). Returns the chosen ApConfig ids via
// NgbActiveModal.close(number[]); dismiss cancels the create.
@Component({
  selector: 'app-select-accounting-systems-modal',
  templateUrl: './select-accounting-systems-modal.component.html',
  styleUrl: './select-accounting-systems-modal.component.less',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SelectAccountingSystemsModalComponent implements OnInit {
  constructor(private Modal: NgbActiveModal) {}

  // The client's create-eligible accounting systems, pre-filtered by the caller.
  @Input() ApConfigs: ApConfig[] = [];

  ApConfigsMap: Map<string, number> = new Map();
  SelectedApConfigIdsMap: Map<string, number> = new Map();

  ngOnInit(): void {
    this.ApConfigsMap = buildApConfigSelectionMap(this.ApConfigs);
  }

  get hasSelection(): boolean {
    return this.SelectedApConfigIdsMap.size > 0;
  }

  apConfigMapChange(selectedItems: Map<string, number>): void {
    this.SelectedApConfigIdsMap = selectedItems;
  }

  submit(): void {
    this.Modal.close(Array.from(this.SelectedApConfigIdsMap.values()));
  }

  close(): void {
    this.Modal.dismiss();
  }
}
